import { ReferenceTopology } from "./reference-topology";
// one reference topology per image
export class ReferenceTopologyManager {
    _referenceTopologyMap;
    constructor() {
        this._referenceTopologyMap = new Map();
    }
    addReferenceTopology(image) {
        const referenceTopology = new ReferenceTopology(image);
        this._referenceTopologyMap.set(image.id, referenceTopology);
    }
    getReferenceTopology(id) {
        return this._referenceTopologyMap.get(id);
    }
    getReferenceTopologies() {
        return Array.from(this._referenceTopologyMap.values());
    }
    deleteReferenceTopology(id) {
        const referenceTopology = this._referenceTopologyMap.get(id);
        if (referenceTopology) {
            referenceTopology.dispose();
            this._referenceTopologyMap.delete(id);
        }
    }
    hasReferenceTopology(id) {
        return this._referenceTopologyMap.has(id);
    }
}
//# sourceMappingURL=reference-topology-manager.js.map